/*
 * @Author: edvardchen
 * @Date: 2017-12-06 11:22:23
 * @Last Modified by: edvardchen
 * @Last Modified time: 2018-03-20 23:12:46
 */

// @flow
export default (timeout: number, promise: Promise<*>): Promise<*> => {
  let timer;

  if (isNaN(timeout)) {
    return promise;
  }

  return Promise.race([
    promise,
    new Promise((resolve, reject) => {
      timer = setTimeout(reject, timeout, new Error(`${timeout}ms timeout`));
    }),
  ]).then(
    (result) => {
      timer && clearTimeout(timer);
      return result;
    },
    (e) => {
      timer && clearTimeout(timer);
      throw e;
    },
  );
};
